/**
 * Tiny module-level register that lets a button click attach a `dispatch_id`
 * to the very next outgoing API request. Used to bridge frontend log events
 * (which know the dispatch_id immediately) and backend log events (which
 * only see it via the `X-Dispatch-Id` request header).
 *
 * Race window is intentional: a click that doesn't fire a request within
 * ~5s gets its id discarded, so a stale id never piggybacks on an
 * unrelated request.
 */

let pendingId = null;
let pendingExpiresAt = 0;

const TTL_MS = 5000;

function uuidv4() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    try { return crypto.randomUUID(); } catch (e) { /* noop */ }
  }
  // Polyfill — good enough for a debug correlation id.
  const tmpl = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return tmpl.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function newDispatchId() {
  return uuidv4();
}

export function armNextDispatchId(id) {
  pendingId = id;
  pendingExpiresAt = Date.now() + TTL_MS;
}

export function consumeNextDispatchId() {
  const now = Date.now();
  if (!pendingId || now > pendingExpiresAt) {
    pendingId = null;
    pendingExpiresAt = 0;
    return null;
  }
  const id = pendingId;
  pendingId = null;
  pendingExpiresAt = 0;
  return id;
}
